// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleSetupFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import fetch from 'share/fetch/Izenda.Fetch';
import { toString } from 'lodash/fp';
const ROOT_URL = 'role/';

export default {
  /**
   * Get list role
   * @returns {*}
   */
  getRoleList(tenantID, includeHashcode, basicInfo) {
    tenantID = tenantID || '';
    includeHashcode = toString(!!includeHashcode);
    basicInfo = toString(!!basicInfo);

    const getRoleListUrl = `${ROOT_URL}all/${tenantID}?includeHashcode=${includeHashcode}&basicInfo=${basicInfo}`;

    return fetch(getRoleListUrl).get();
  },

  /**
   * Get list Access role
   * @returns {*}
   */
  getTypedRole(type, tenantID) {
    tenantID = tenantID || '';
    return fetch(String.format('{0}availableRole/{1}/{2}', ROOT_URL, type, tenantID)).get();
  },

  /**
   * Get list Access role
   * @returns {*}
   */
  getTypedCategory(type, tenantID) {
    tenantID = tenantID || '';
    return fetch(String.format('{0}availableCategory/{1}/{2}', ROOT_URL, type, tenantID)).get();
  },

  /**
   * Load Lazy Typed Category
   * @returns {*}
   */
  loadLazyTypedCategory(data) {
    return fetch(String.format('{0}availableCategory/', ROOT_URL)).post(data);
  },

  /**
   * activate Role
   * @method activateRole
   * @param  {string}     roleId Role ID
   * @return {Promise}           API Promise
   */
  activateRole(roleId, tenantId) {
    const tenantParam = tenantId ? `/${tenantId}` : '';
    return fetch(`${ROOT_URL}active/${roleId}${tenantParam}`).post();
  },

  /**
   * deactivate Role
   * @method deactivateRole
   * @param  {string}     roleId Role ID
   * @return {Promise}           API Promise
   */
  deactivateRole(roleId, tenantId) {
    const tenantParam = tenantId ? `/${tenantId}` : '';
    return fetch(`${ROOT_URL}deactive/${roleId}${tenantParam}`).post();
  },

  /**
   * delete Role
   * @method deleteRole
   * @param  {string}     roleId Role ID
   * @return {Promise}           API Promise
   */
  deleteRole(roleId) {
    return fetch(ROOT_URL + roleId).delete();
  },

  /**
   * load Role
   * @method loadRole
   * @param  {string}     roleId Role ID
   * @return {Promise}           API Promise
   */
  loadRole(roleId) {
    return fetch(ROOT_URL + roleId, { prefer: 'minimal' }).get();
  },

  /**
   * save Role
   * @method saveRole
   * @param  {string}     roleId Role ID
   * @return {Promise}           API Promise
   */
  saveRole(saveData) {
    return fetch(ROOT_URL, { prefer: 'minimal' }).post(saveData);
  },

  /**
   * load Permission Summary
   * @param  {string} tenantId
   * @return {promise}
   */
  loadPermissionSummary(tenantId) {
    tenantId = tenantId || '';
    return fetch(`${ROOT_URL}summaries/${tenantId}`).get();
  },

  /**
   * Load list sharing roles
   * @return Promise: roles list.
   */
  loadAllowedSharingRoles(requestData) {
    return fetch(`${ROOT_URL}allowedSharingRoles`).post(requestData);
  },

  /**
   * Load list sharing roles paging
   * @return {Promise}
   */
  loadAllowedSharingRolesPaging(requestData) {
    return fetch(`${ROOT_URL}allowedSharingRolesPaging`).post(requestData);
  },

  /**
   * Load partial access limits
   * @param  {Object} data
   * @return {Promise}
   */
  loadPartialAccessLimits(data) {
    return fetch(`${ROOT_URL}accessLimits`).post(data);
  },

  /**
   * Load partial schedule limits
   * @param  {Object} data
   * @return {Promise}
   */
  loadPartialScheduleLimits(data) {
    return fetch(`${ROOT_URL}scheduleLimits`).post(data);
  },

  /**
   * Load Partial DataModel Access
   * @param  {Object} data
   * @return {Promise}
   */
  loadPartialDataModelAccess: function(data) {
    return fetch(ROOT_URL + 'loadPartialDataModelAccess').post(data);
  }
};



// WEBPACK FOOTER //
// ./ui/fetchers/Izenda.RoleSetupFetcher.js